export default "__VITE_ASSET__jgEgbnwo__"